import React, { FunctionComponent, useCallback, useState } from 'react';
import { useRobloxAuthentication } from '@rbx/auth';
import { MenuItem, Typography } from '@rbx/ui';
import { AuthenticationStatusV2 } from '../../topNavigation/components/AuthenticationStatus';
import useProductUrls from '../../utils/useProductUrls';

export type TMenuItem = {
  label: string;
  href: string;
  onClick?: VoidFunction;
};

type TAuthenticationStatusContainerProps = {
  menuItems?: TMenuItem[];
};

const AuthenticationStatusContainer: FunctionComponent<TAuthenticationStatusContainerProps> = ({
  menuItems,
}) => {
  const {
    Dashboard: { creatorSettings },
  } = useProductUrls();
  const { login, logout, user, isFetched: isUserFetched } = useRobloxAuthentication();

  const [isLogoutInProgress, setIsLogoutInProgress] = useState<boolean>(false);

  const onLogout = useCallback(async () => {
    setIsLogoutInProgress(true);
    try {
      await logout();
    } catch {
      // fail slightly
    }
    setIsLogoutInProgress(false);
  }, [logout]);

  const dropDownContent = menuItems?.map(({ href, onClick, label }) => (
    <MenuItem key={href} role='menuitem' component='a' onClick={onClick} href={href}>
      <Typography>{label}</Typography>
    </MenuItem>
  ));

  return (
    <AuthenticationStatusV2
      user={user}
      loading={!isUserFetched || isLogoutInProgress}
      onLogout={onLogout}
      onLogin={login}
      settingsHref={creatorSettings}
      desktopDropdownContent={dropDownContent}
      avatarOnly
    />
  );
};

export default AuthenticationStatusContainer;
